import { patch } from './utils'

export async function updateMetatext(record, path, { title, meta_description }) {
  const params = { post: { title, meta_description } }
  const response = await patch(path, params)
  return response.data
}
